import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute.js"

import AddQA from "./Q&A/Create.js"
import QA from "./Q&A/View.js"
import ProtectedRoute from "../RouteProtect.js"


const RoutesArray = [
    {
        path: "*",
        element: <h1>This is 404</h1>
    },
    {
        path: "",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <QA />
                </ProtectedRoute>
            )
    },
    {
        path: "/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "/addQuestion",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <AddQA />
            </ProtectedRoute>
        )
    },
   
];


export default function MangeRoutes() {
    return useRoutes(RoutesArray)
};